import React from "react";
//#region types
import { InvoiceDraftFooterProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { StyleEnums } from "models/enums";
//#endregion
//#region components
import { WizardFormFooter } from "components/common";
import InvoiceWizardMoreActions from "./forms/create/wizardMoreActions";
//#endregion

const InvoiceDraftFooter: React.FC<InvoiceDraftFooterProps> = (props) => {
  const {
    invoiceId,
    onShowInvoicePreview,
    submitInvoice,
    reloadInvoice,
    isFormLoading,
    invoiceOwnerId,
    wizardProps,
    forwardedCosts,
  } = props;

  return (
    <WizardFormFooter
      actions={[
        {
          text: TranslationKeys.Common.FinalReview,
          onClick: onShowInvoicePreview,
          type: StyleEnums.DisplayType.Success,
          isDisabled: isFormLoading,
          testId: "finalReviewButton",
        },
      ]}
      moreActions={
        <InvoiceWizardMoreActions
          createInvoiceHandler={submitInvoice}
          reloadInvoiceHandler={reloadInvoice}
          invoiceId={invoiceId}
          invoiceOwnerId={invoiceOwnerId}
          forwardedCosts={forwardedCosts}
        />
      }
      isFormValid={!isFormLoading}
      wizardProps={wizardProps}
    />
  );
};

export default InvoiceDraftFooter;
